export default {
    attribute: {//配置项
        total: 0,
        current: 1,
        pageSize: 5,
        size: "small",
        textColor: "#fff", //文字颜色
        textColorArrow: "#000", //箭头颜色
        backgroundColor: "#222222", //背景颜色
        backgroundColorCurrent: "#06aabd", //选中背景颜色
        autoSwitch: true,
        autoSwitch_num: true,// 总数量
        autoSwitch_dropdown: true,
        pageSizeOptions: [
            {
                label: `5 条/页`,
                value: 5
            },
            {
                label: `10 条/页`,
                value: 10
            }, {
                label: `20 条/页`,
                value: 20
            }
            , {
                label: `50 条/页`,
                value: 50
            }

        ]

    },
    cptDataForm: {//动态数据配置
        dataSource: 1, //默认数据源1:静态数据，2:api接口,3:SQL,4:数据集,5:websocket
        pollTime: 0,//默认轮询时间
        dataText: '{"value": "文本组件动态数据"}',//静态数据，必须为JSON格式
        apiUrl: '/test',//默认api地址
        sql: 'select xxx'//默认sql
    }
}